import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import Backdrop from "@material-ui/core/Backdrop";
import { withStyles } from "@material-ui/core/styles";
import styles from './style.module.css';

import momentJalaali from "moment-jalaali";
import moment from "moment";
import {
  NewTravelPickupSetReserve,
  NewTravelDropOffSetReserve,
  EditTravelPickupSetReserve,
  EditTravelDropOffSetReserve,
  Edit_Travel_Operate_Changed,
} from "../../../../../Redux/actions/actionNames";
import {
  checkTimestamp,
  get_dateFormat,
  get_lang,
  get_timeFormat,
} from "../../../../../helper/UserData/userdate";
import { default as ButtonD } from "../../../../../design-system/lib/Button/index";

import jalali from "jalali-moment";
import { snack } from "../../../../../utils/SnackbarUtilsConfigurator";
import { ARROW_DOWN, arrowTop, CALENDAR_CHECK, calendar_time_gray, CLOCK, CLOCK_1, CLOSE, SCHEDULE, TIMER } from "../../../../../assets";
import Modal from "../../../../../design-system/lib/Modal";
import Typography from "../../../../../design-system/lib/Typography";
import IconProvider from "../../../../../design-system/lib/IconProvider";
import DropDown from "../../../../../design-system/lib/DropDown";

 
 import Calendar_time from "../../../../../assets/IconProvider/calendar_time.svg";
  import ArrowDown from "../../../../../assets/IconProvider/Arrow---Down-2 copy.svg";
import { Calendar } from "@amir04lm26/react-modern-calendar-date-picker";

const BackdropCustom = withStyles({
  backdrop: {
    zIndex: 5000,
    backgroundColor: "rgba(0, 0, 0, 0)",
    color: "#00000",
  },
})((props) => (
  <Backdrop
    {...props}
    style={{
      zIndex: 5000,
      backgroundColor: "rgba(0, 0, 0, 0)",
      color: "#00000",
    }}
  />
));

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      
      edited:false ,

      TABIndex: (!momentJalaali(this.props.scheduleDateAfter).isValid() ||
              !momentJalaali(this.props.scheduleDateBefore).isValid()) ? 0 : 1,
      showTimePickerDialoge: false,
      TimeSelected: false,
      forNow:
        props.scheduleDateAfter || props.scheduleDateBefore ? true : true,
      Dialoge: false,
      Date: momentJalaali(),
      init: moment(),
      scheduleDateBefore: null,
      scheduleDateAfter: null,
      activeDialoge: null,
      rangeTime: [],
      selectedTime: null,
      min: moment(
        Date.now() +
        props.activeVehicleType.scheduleSetting.scheduleDateRangeAfter
      ),
      max: moment(
        Date.now() +
        props.activeVehicleType.scheduleSetting.scheduleDateRangeBefore
      ),
    };
    this.confirm = this.confirm.bind(this);
    this.timePickerRef = React.createRef();
  }

  componentWillReceiveProps(nextProps) {
    try {
      if (
        nextProps.activeVehicleType &&
        nextProps.activeVehicleType.scheduleSetting
      ) {
        this.setState({
          min: moment(
            Date.now() +
            nextProps.activeVehicleType.scheduleSetting.scheduleDateRangeAfter
          ),
          max: moment(
            Date.now() +
            nextProps.activeVehicleType.scheduleSetting
              .scheduleDateRangeBefore
          ),
        });
      }
    } catch (error) { }

        this.setState({
          TABIndex: (!momentJalaali(nextProps.scheduleDateAfter).isValid() ||
            !momentJalaali(nextProps.scheduleDateBefore).isValid()) ? 0 : 1,
        })

  }

  handleToggle = (b) => {
    if (
      parseInt(
        this.props.activeVehicleType.scheduleSetting.scheduleDateRangeBefore
      ) == 0
    ) {
      snack.warning_i18("errorInPanelSetting")

    } else {
      this.setState({
        showTimePickerDialoge: b,
      });
    }
  };

  componentDidMount() { }

  handleDialoge = (e) => {
    //   if (this.props.activePickupDropOff.type === "pickup") {

    this.setState({
      Date: moment(),
      ActiveFild: e,
      activeDialoge: e,
      // scheduleDateBefore: momentJalaali(this.props[e]).isValid()
      //   ? this.props[e]
      //   : momentJalaali(),
      // scheduleDateAfter: momentJalaali(this.props[e]).isValid()
      //   ? this.props[e]
      //   : momentJalaali(),
      selectedTime:null,
        scheduleDateBefore: null,
        scheduleDateAfter: null,
      Dialoge: !this.state.Dialoge,
      TimeSelected: false,
    });
    //  }
  };

  handleSwitch = () => {
    if (this.props.activePickupDropOff.type === "pickup") {
      this.props.dispatch(
        EditTravelPickupSetReserve({
          name: "scheduleDateBefore",
          value: null,
        })
      );
      this.props.dispatch(
        EditTravelPickupSetReserve({
          name: "scheduleDateAfter",
          value: null,
        })
      );
    } else {
      this.props.dispatch(
        EditTravelDropOffSetReserve({
          name: "scheduleDateBefore",
          value: null,
          firstDropOff: this.props.firstDropOff,
          id: this.props.firstDropOff ? "dropoff" : this.props.id,
        })
      );
      this.props.dispatch(
        EditTravelDropOffSetReserve({
          name: "scheduleDateAfter",
          value: null,
          firstDropOff: this.props.firstDropOff,
          id: this.props.firstDropOff ? "dropoff" : this.props.id,
        })
      );
    }

    this.setState({
      forNow: !this.state.forNow,
    });
  };

  checkSekectedTime = () => {
    if (this.state.selectedTime) {
      return `${this.state.selectedTime.scheduleDateAfter.hour}:${this.state.selectedTime.scheduleDateAfter.minute} - ${this.state.selectedTime.scheduleDateBefore.hour}:${this.state.selectedTime.scheduleDateBefore.minute}`
    } else {
      return this.props.t("PleaseSelect")
    }
  }

  SetTime = (date) => {
    //   if (this.props.activePickupDropOff.type === "pickup") {

    let scheduleDateBefore = moment(this.state.selectedDate).set({
      hour: moment(date.data[1]).format("HH"),
      minute: moment(date.data[1]).format("mm"),
    });
    let scheduleDateAfter = moment(this.state.selectedDate).set({
      hour: moment(date.data[0]).format("HH"),
      minute: moment(date.data[0]).format("mm"),
    });

    this.setState(
      {
        scheduleDateBefore: scheduleDateBefore,
        scheduleDateAfter: scheduleDateAfter,
        TimeSelected: true,
        selectedTime: {
          scheduleDateBefore: {
            hour: moment(date.data[1]).format("HH"),
            minute: moment(date.data[1]).format("mm"),
          },
          scheduleDateAfter: {
            hour: moment(date.data[0]).format("HH"),
            minute: moment(date.data[0]).format("mm"),
          },
        },
      },
      () => {
        this.handleToggle(false);
      }
    );
    // }
  };;

  SetDate = (e) => {
    // if (this.props.activePickupDropOff.type === "pickup") {
          var mydate = new Date(`${e.year}-${e.month}-${e.day}`);

    let dateStr = momentJalaali(mydate).format("YYYY-MM-DD"),
      timeStr = momentJalaali(this.state[this.state.ActiveFild]).format(
        "HH:mm"
      ),
      date = moment(dateStr),
      time = moment(timeStr, "HH:mm");

    date.set({
      hour: time.get("hour"),
      minute: time.get("minute"),
      second: time.get("second"),
    });
    this.setState({
      Date: date,
      // scheduleDateBefore: date,
      // scheduleDateAfter: date,
      TimeSelected: false,
      CalendarDate  : e , 
      selectedDate: dateStr,
      selectedTime: null,
      edited : true
    }, () => {
      this.TimesProvider()
    });
    // this.props.dispatch(
    //   NewTravelPickupSetReserve({
    //     name: this.state.ActiveFild,
    //     value: date,
    //   })
    // );
    //  }
  };

  confirm = () => {
  

          if((this.state.TABIndex == 1 || !this.props.activeVehicleType?.scheduleSetting?.isPickupNowActive) && this.state.selectedTime) {
    if (this.props.activePickupDropOff.type === "pickup") {
      this.setState({
        Dialoge: false,
      });
      this.props.dispatch(
        EditTravelPickupSetReserve({
          name: "scheduleDateBefore",
          value: this.state["scheduleDateBefore"],
        })
      );
      this.props.dispatch(
        EditTravelPickupSetReserve({
          name: "scheduleDateAfter",
          value: this.state["scheduleDateAfter"],
        })
      );
    } else {
      this.setState({
        Dialoge: false,
      });
      this.props.dispatch(
        EditTravelDropOffSetReserve({
          name: "scheduleDateBefore",
          value: this.state["scheduleDateBefore"],
          firstDropOff: this.props.firstDropOff,
          id: this.props.firstDropOff ? "dropoff" : this.props.id,
        })
      );
      this.props.dispatch(
        EditTravelDropOffSetReserve({
          name: "scheduleDateAfter",
          value: this.state["scheduleDateAfter"],
          firstDropOff: this.props.firstDropOff,
          id: this.props.firstDropOff ? "dropoff" : this.props.id,
        })
      );



    }
          }else{
this.cancel()
          }
    


    this.props.dispatch(Edit_Travel_Operate_Changed());

  };

  cancel = () => {
    this.setState({
      [this.state.activeDialoge]: null,
    });
    if (this.props.activePickupDropOff.type === "pickup") {
      this.setState({
        Dialoge: false,
      });
      this.props.dispatch(
        EditTravelPickupSetReserve({
          name: "scheduleDateBefore",
          value: 0,
        })
      );
      this.props.dispatch(
        EditTravelPickupSetReserve({
          name: "scheduleDateAfter",
          value: 0,
        })
      );
    } else {
      this.setState({
        Dialoge: false,
      });
      this.props.dispatch(
        EditTravelDropOffSetReserve({
          name: "scheduleDateBefore",
          value: null,
          firstDropOff: this.props.firstDropOff,
          id: this.props.firstDropOff ? "dropoff" : this.props.id,
        })
      );

      this.props.dispatch(
        EditTravelDropOffSetReserve({
          name: "scheduleDateAfter",
          value: null,
          firstDropOff: this.props.firstDropOff,
          id: this.props.firstDropOff ? "dropoff" : this.props.id,
        })
      );
    }
    this.props.dispatch(Edit_Travel_Operate_Changed());

  };

  controlThatbeforeLoweEqualAfter = () => {
    if (!this.state.scheduleDateAfter || !this.state.scheduleDateBefore) {
      return true;
    } else if (
      moment(this.state.scheduleDateBefore).isAfter(
        this.state.scheduleDateAfter
      ) ||
      moment(this.state.scheduleDateBefore).isSame(this.state.scheduleDateAfter)
    ) {
      return true;
    } else {
      return false;
    }
  };

  controlThatbeforeAndAfterMustBiggerthanCurrentDate = () => {
    if (
      (this.state.scheduleDateBefore
        ? moment(this.state.scheduleDateBefore).isAfter(new Date())
        : true) &&
      (this.state.scheduleDateAfter
        ? moment(this.state.scheduleDateAfter).isAfter(new Date())
        : true)
    ) {
      return true;
    } else {
      return false;
    }
  };

  diffDays = (IsfirstDay, IslastDay, IsOneDay, start, end, step) => {
    const today = start;
    const endDate = end;
    const minutes = Math.ceil(
      (Math.abs(endDate.unix() - today.unix()) / (1000 * 60)) % 60
    );
    const allSteps = Math.ceil(
      Math.abs(endDate.unix() - today.unix()) / 60 / step
    );
    // )
    // )
    // )
    // )
    // 
    // 
    // .format("HH:mm MM/DD ") , moment(endDate).format("HH:mm MM/DD "))

    let arr = [];
    arr.push([today, moment(today).add(step, "minute")]);

    for (let i = 1; i < allSteps; i++) {
      if (i == allSteps - 1) {
        if (!IsfirstDay && !IslastDay && !IsOneDay) {
          arr.push([
            moment(arr[arr.length - 1][1]),
            moment(endDate).set({ hour: 23, minute: 59 }),
          ]);
        } else if (IsfirstDay) {
          arr.push([moment(arr[arr.length - 1][1]), endDate]);
        }
      } else {
        arr.push([
          moment(arr[arr.length - 1][1]),
          moment(arr[arr.length - 1][1]).add(step, "minute"),
        ]);
      }
    }

    // arr.forEach(element => {
    //   .format("HH:mm MM/DD") , moment(element[1]).format("HH:mm MM/DD"))
    // });

    // return arr;
    this.setState({
      rangeTime: arr
    })
  };

  TimesProvider = () => {
    const step =
      this.props.activeVehicleType.scheduleSetting.scheduleDateStep / 1000 / 60;
    if (
      parseInt(
        this.props.activeVehicleType.scheduleSetting.scheduleDateRangeBefore
      ) == 0
    ) {
      return [];
    } else if (
      moment(this.state.min).format("MM/DD") ==
      moment(this.state.max).format("MM/DD")
    ) {
      //One Day
      return this.diffDays(
        false,
        false,
        true,
        moment(Date.now()).add(step, "minute"),
        moment(this.state.max),
        step
      );
    } else if (
      moment(this.state.init).format("MM/DD") ==
      moment(this.state.Date).format("MM/DD")
    ) {
      //the first
      return this.diffDays(
        true,
        false,
        false,
        moment(Date.now()).add(step, "minute"),
        moment(this.state.min).add(step, "minute").endOf("day"),
        step
      );
    } else if (
      moment(this.state.max).format("MM/DD") ==
      moment(this.state.Date).format("MM/DD")
    ) {
      //the last
      return this.diffDays(
        false,
        true,
        false,
        moment(this.state.max).startOf("day"),
        moment(this.state.max),
        step
      );
    } else {
      //the midd
      return this.diffDays(
        false,
        false,
        false,
        moment(this.state.Date).startOf("day"),
        moment(this.state.Date).endOf("day").add(-3, "minute"),
        step
      );
    }
  };

  getDaysOfDate = () => {
    let diff = moment(this.state.max).diff(moment(this.state.min), "days");

    let diffminute = moment(this.state.max).diff(moment(this.state.min), "minute");


    let arr = [];
    let min = moment(this.state.min).startOf("day");
    let max = moment(this.state.max).startOf("day");

    if (diff > 0) {
      arr.push(min);
      for (let i = 0; i < diff; i++) {
        arr.push(moment(min).add(i + 1, "day"));
      }
      return arr;
    } else {
      let step = this.props.activeVehicleType.scheduleSetting.scheduleDateStep / 1000 / 60;
      if (diffminute = moment(this.state.max).diff(moment(this.state.min), "minute") >= step) {
        arr.push(min);
        if (momentJalaali(this.state.max).format(
          get_lang() == "fa" ? "jMM/jDD" : "MM/DD"
        ) != momentJalaali(this.state.min).format(
          get_lang() == "fa" ? "jMM/jDD" : "MM/DD"
        )) {
          arr.push(max);
          return arr;
        } else {
          return arr;
        }
      } else {
        return arr;
      }

    }
  };

  checkSekectedDate = (day) => {
    if (this.state.selectedDate) {
      if (
        moment(day).format("MM/DD") ==
        moment(this.state.selectedDate).format("MM/DD")
      ) {
        return true
      }
    } else {
      return false;
    }
  };



  
    getValueDate = () => {
  
      if(this.state.selectedDate){
        return {
          year: this.state.CalendarDate?.year ,
          month: this.state.CalendarDate?.month,
          day: this.state.CalendarDate?.day
        }
      }else {
        return null
      }
  
    }
  
    getMinimumDate = (arr) => {
      console.log("dwdwdwdwdwd ",arr)
    if(arr && arr.length > 0){
      return {
        year: momentJalaali(arr[0]).format(
          get_lang() == "fa" ? "jYYYY" : "YYYY"
        ) ,
        month: momentJalaali(arr[0]).format(
          get_lang() == "fa" ? "jMM" : "MM"
        ),
        day: momentJalaali(arr[0]).format(
          get_lang() == "fa" ? "jDD" : "DD"
        )
      }
    }else{
      return null
    }
    };
  
    getMaximumDate = (arr) => {
      console.log("dwdwdwdwdwd ",arr)
  
      if(arr && arr.length > 0){
        return {
          year: momentJalaali(arr[arr.length - 1]).format(
            get_lang() == "fa" ? "jYYYY" : "YYYY"
          ) ,
          month: momentJalaali(arr[arr.length - 1]).format(
            get_lang() == "fa" ? "jMM" : "MM"
          ),
          day: momentJalaali(arr[arr.length - 1]).format(
            get_lang() == "fa" ? "jDD" : "DD"
          )
        }
      }else{
        return null
      }
    };

  render() {
    // this.diffDays();
    const { t } = this.props;
    let DaysOfDate = this.getDaysOfDate()
    // let TimesProvider = this.TimesProvider()

    console.log("xoperth ",this.state , this.props)
    return (
      <div className="ScheduleContainer" style={{ margin: "0px" , width:"auto",marginInlineStart:"auto" , height:'auto' }}>
 
        <React.Fragment>

          {/* <ButtonD className={styles.NoMaxWidth} size="Medium" type="Secondary" icon={TIMER} text={ ( this.props.scheduleDateAfter && this.props.scheduleDateBefore && momentJalaali(this.props.scheduleDateAfter).isValid() &&
            momentJalaali(this.props.scheduleDateBefore).isValid()) ? (
            `${jalali(this.props.scheduleDateAfter)
              .locale(get_lang())
              .format(checkTimestamp(this.props.scheduleDateAfter))} - ${jalali(
                this.props.scheduleDateBefore
              )
                .locale(get_lang())
                .format(get_timeFormat())}`
          ) : (
            <Trans i18nKey={"Settime"}> </Trans>
          )} style={{ width: "calc(100% - 16px)", justifyContent: "start" }} onClick={() => this.handleDialoge("scheduleDateAfter")} isActive={momentJalaali(this.props.scheduleDateAfter).isValid() && momentJalaali(this.props.scheduleDateBefore).isValid()} />
 */}


        <div  onClick={() => this.handleDialoge("scheduleDateAfter")} style={{display:"flex",flexDirection:"row", gap:"4px" , justifyContent:"center" , alignItems:"center" , cursor:"pointer"}}>
            {this.props.scheduleDateAfter && (momentJalaali(this.props.scheduleDateAfter).isValid() &&
            momentJalaali(this.props.scheduleDateBefore).isValid()) ? <>
                    <img src={Calendar_time} size='16' />  
            <Typography text={`${jalali(this.props.scheduleDateAfter)
              .locale(get_lang())
              .format(checkTimestamp(this.props.scheduleDateAfter))} - ${jalali(
                this.props.scheduleDateBefore
              )
                .locale(get_lang())
                .format(get_timeFormat())}`} weight='Body_Small_Medium' />
             <img src={arrowTop}  size="10" style={{transform :"rotate(180deg)"}} />  
            </> : <>
            <img src={Calendar_time} size='16' />  
            <Typography text={this.props.activeVehicleType?.scheduleSetting?.isPickupNowActive ? this.props.t("ASAP") : this.props.t("Schedule")} weight='Body_Small_Medium' />
             <img src={arrowTop}  size="12" style={{transform :"rotate(180deg)"}} />  
            </>}
          </div>
 
 
          {/* {this.state.Dialoge && <Modal ConfirmationOnClick={this.state.selectedTime ? this.confirm : null} CancelOnClick={() => { }} onclose={this.handleDialoge} size='large'
            icon={CLOSE} footer={<div style={{ flex: "1", flexDirection: "row", display: "flex", alignItems: "center" }} >
              <div className="ScheduleDialogeFooterDateTime" style={{ flex: "1" }}>
                <Typography text={(momentJalaali(this.state.scheduleDateAfter).isValid() &&
                  momentJalaali(this.state.scheduleDateBefore).isValid()) ? (
                  <p className="time">
                    {moment(this.state.scheduleDateAfter).format(checkTimestamp(this.state.scheduleDateAfter))} -{" "}
                    {moment(this.state.scheduleDateBefore).format(get_timeFormat())}
                  </p>
                ) : (
                  "- - - - - - "
                )} weight='Body_Middle_Bold' />

                <Typography text={"Selected date and time"} weight='Subtitle_Tiny_Regular' />
              </div>

              {(momentJalaali(this.props.scheduleDateAfter).isValid() &&
                momentJalaali(this.props.scheduleDateBefore).isValid()) && <ButtonD className={styles.NoMaxWidth} size="Medium" type="Secondary" onClick={this.cancel} text={this.props.t("clear")} style={{ marginInlineEnd: "16px" }} />}
            </div>}

            title={this.props.t("Schedule")} body={<div className={styles.twoColumns}>
              <div className={styles.Column}>
                <div className={styles.title}> <IconProvider Icon={CALENDAR_CHECK} /> <Typography text={this.props.t("Date")} weight='Body_Middle_Bold' /></div>
                <DropDown placement="bottomStart" size='Medium' data={DaysOfDate.map((dod) => { return { data: dod, title: momentJalaali(dod).format(get_dateFormat()) } })} onClick={this.SetDate} text={this.state.selectedDate ? moment(this.state.selectedDate).format(get_dateFormat()) : (DaysOfDate.length > 0 ? this.props.t("PleaseSelect") : this.props.t("noDateToShow"))} />
              </div>
              <div className={styles.Column}>
                <div className={styles.title}> <IconProvider Icon={CLOCK_1} /> <Typography text={this.props.t("Time")} weight='Body_Middle_Bold' /></div>
                <DropDown placement="bottomStart" size='Medium' data={this.state.rangeTime.map((dod) => {
                  return {
                    data: dod, title: `${moment(dod[0]).format(get_timeFormat())} - ${moment(
                      dod[1]
                    ).format(get_timeFormat())}`
                  }
                })} onClick={this.SetTime} text={this.checkSekectedTime()} />
              </div>
            </div>} CancelText={this.props.t("clear")} ConfirmationText={this.props.t("Savechanges")} />}
 */}


          {this.state.Dialoge && <Modal ConfirmationOnClick={this.confirm} CancelOnClick={() => { }} onclose={this.handleDialoge} size='large'
            icon={CLOSE}

            footer={<div style={{ flex: "1", flexDirection: "row", display: "flex", alignItems: "center" }} >

            </div>}

            title={this.props.t(`Schedule${this.props.activePickupDropOff.type}`)}
            body={<>
              {this.props.activeVehicleType?.scheduleSetting?.isPickupNowActive && <div className={styles.tabContainer}>
                <div className={`${styles.tabBTN} ${(this.state.TABIndex == 0) && styles.tabBTN_Active}`} onClick={() => { this.setState({ TABIndex: 0 }) }}>{this.props.t("ASAP")}</div>
                <div className={`${styles.tabBTN} ${((this.state.TABIndex == 1)) && styles.tabBTN_Active}`} onClick={() => { this.setState({ TABIndex: 1 }) }} >{this.props.t("Schedule")}</div>

              </div>}
              {(this.state.TABIndex == 1 || !this.props.activeVehicleType?.scheduleSetting?.isPickupNowActive) && <div className={styles.twoColumns}>
                <Calendar
                  minimumDate={this.getMinimumDate(DaysOfDate)}
                  maximumDate={this.getMaximumDate(DaysOfDate)}
                  value={this.getValueDate()}
                  onChange={(e) => { this.SetDate(e) }}
                  shouldHighlightWeekends
                  colorPrimary={"#2980ff"} // added this
                  colorPrimaryLight="#148be940" // and this
                  calendarClassName={styles.customCalendar}
                />
                <div className={styles.Column} style={{ minWidth: "238px" }}>
                  <div className={styles.title}>  <Typography text={this.props.t("Time slot")} weight='Body_Small_Regular' /></div>
                  <DropDown isRequired={true}
                    IconComponents={<img src={CLOCK} size="16" />}
                    placement="topStart" size='Medium' data={this.state.rangeTime.map((dod) => {
                      return {
                        data: dod, title: `${jalali(dod[0]).locale(get_lang()).format(get_timeFormat())} - ${jalali(
                          dod[1]
                        ).locale(get_lang()).format(get_timeFormat())}`
                      }
                    })} onClick={this.SetTime} text={this.checkSekectedTime()} />
                </div>
              </div>

              }
            </>
            } CancelText={this.props.t("clear")} ConfirmationDisabled={(this.state.TABIndex == 1 || !this.props.activeVehicleType?.scheduleSetting?.isPickupNowActive) ? (!this.state.edited || !this.state.selectedTime || !this.state.selectedDate) : false} ConfirmationText={this.props.t("Savechanges")} />}

        </React.Fragment>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  direction: state.LocalData.direction,
  lang: state.LocalData.lang
});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(App));
